import { useState, useEffect } from 'react';
import { MapPin, ChevronDown } from 'lucide-react';
import { useCart } from '@/context/CartContext';

export default function Header({ onAddressClick }) {
  const { zone } = useCart();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      data-testid="header"
      className={`sticky top-0 z-40 transition-all duration-300 border-b ${
        scrolled
          ? 'bg-[#0a0a0a]/98 backdrop-blur-xl border-zinc-800/60 shadow-lg shadow-black/30'
          : 'bg-[#0a0a0a]/95 backdrop-blur-md border-zinc-800/40'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 h-16 flex items-center justify-between">
        <a href="/" className="flex items-center gap-2.5">
          <img
            src="/logo-transparent.png"
            alt="Sushi Express"
            data-testid="header-logo"
            className="h-10 md:h-14 w-auto drop-shadow-[0_0_14px_rgba(232,76,28,0.6)] transition-all duration-300"
          />
        </a>
        <button
          data-testid="header-address-btn"
          onClick={onAddressClick}
          className="flex items-center gap-1.5 text-sm max-w-[200px] truncate hover:text-[#E84C1C] transition-colors"
        >
          <MapPin size={16} className="text-[#E84C1C] shrink-0" />
          <span className="truncate text-zinc-300">
            {zone ? zone.name : 'Elegir dirección'}
          </span>
          <ChevronDown size={14} className="text-zinc-500 shrink-0" />
        </button>
      </div>
    </header>
  );
}
